<template>
    <div class="container d-flex justify-content-center align-items-center min-vh-100">
        <div class="login-card card shadow-lg p-4 rounded">
            <h2 class="card-title text-center mb-4">Login</h2>
            <form @submit.prevent="login">
                <div class="form-group">
                    <label for="username" class="form-label">Username</label>
                    <input class="form-control" type="text" v-model="username" id="username" required />
                </div>
                <div class="form-group mt-3">
                    <label for="password" class="form-label">Password</label>
                    <input class="form-control" type="password" v-model="password" id="password" required />
                </div>
                <div class="text-center mt-4">
                    <button type="submit" class="btn btn-primary w-100">Login</button>
                </div>
            </form>
            <p v-if="error" class="error text-danger mt-3 text-center">{{ error }}</p>
        </div>
    </div>
</template>

  
  
<script>
import axios from 'axios';

export default {
    data() {
        return {
            username: '',
            password: '',
            error: ''
        };
    },
    mounted() {
        if(window.location.href.includes('localhost')){
            this.username = 'developer';
            this.password = 'password';
        }
    },
    methods: {
        login() {
            let apiUrl = `${process.env.VUE_APP_BASE_URL}/api.php?action=login&type=report&platform=report`;

            axios.post(apiUrl, {
                    username: this.username,
                    password: this.password
                })
                .then(response => {
                    if (response.data.status === 'success') {
                        localStorage.setItem('username', response.data.username);
                        localStorage.setItem('userToken', response.data.token);
                        if(response.data.result){
                            localStorage.setItem('role', response.data.result.role);
                        }
                        this.$router.push('/admin');
                    } else {
                        alert(response.data.message);
                        this.error = response.data.message;
                    }
                })
                .catch(error => {
                    alert('Network Error: ' + error);
                });
        }
    }
};
</script>
  
<style scoped>
.login-card {
    max-width: 400px;
    width: 100%;
}

.login-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: #f5f5f5;
}

.login-card {
    padding: 20px;
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    width: 300px;
    text-align: center;
}

.form-group {
    margin-bottom: 15px;
}

.error {
    font-size: 0.875rem;
    color: red;
    margin-top: 10px;
}
</style>
